import { Component, Inject, InjectionToken , HostListener } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';
import { FilteredEntityField } from './covance-chain-filter';

export const CHAIN_NODE_DIALOG_ARGS = new InjectionToken('ChainNodeDialogArgs');

export interface ChainNodeDialogArgs {
    fields: FilteredEntityField<any>[];
}

export interface ChainNodeDialogResult {
    fieldName: string;
    title: string;
}

@Component({
    selector: 'chain-node-dialog',
    template: require('./chain-node-dialog.component.html'),
    styles: [require('./chain-node-dialog.component.scss')]
})
export class ChainNodeDialogComponent {
    public readonly fields: FilteredEntityField<any>[];
    public selectedField: FilteredEntityField<any>;
    public title: string;

    constructor(
        private dialog: MdlDialogReference,
        @Inject(CHAIN_NODE_DIALOG_ARGS) args: ChainNodeDialogArgs
    ) {
        this.fields = args.fields;
        this.selectedField = args.fields[0];
    }

    public onChangeField(field: FilteredEntityField<any>) {
        this.selectedField = field;
        this.title = field.title;
    }

    @HostListener('document:keydown.enter')
    public ok() {
        if (!this.selectedField || !this.selectedField.fieldName || !this.title) {
            return;
        }

        this.dialog.hide({
            fieldName: this.selectedField.fieldName,
            title: this.title
        } as ChainNodeDialogResult);
    }

    @HostListener('document:keydown.esc')
    public close() {
        this.dialog.hide();
    }
}